const COOKIE_NAME = 'azds_age_confirmed';
const COOKIE_MAX_AGE = 60 * 60 * 24 * 365;

const setConfirmedCookie = () => {
  const secure = window.location.protocol === 'https:' ? '; Secure' : '';
  document.cookie = `${COOKIE_NAME}=1; path=/; max-age=${COOKIE_MAX_AGE}; SameSite=Lax${secure}`;
};

const ageGate = {
  init() {
    const form = document.querySelector('[data-age-gate]');
    if (!form) return;

    this.form = form;
    this.redirect = form.dataset.redirect || '/';
    this.denyRedirect = form.dataset.denyRedirect || 'https://www.google.com/';
    this.choices = Array.from(form.querySelectorAll('[data-age-gate-choice]'));
    this.error = form.querySelector('[data-age-gate-error]');
    if (this.choices.length === 0) return;

    this.choices.forEach((choice) => {
      choice.addEventListener('change', () => this.clearError());
    });

    form.addEventListener('submit', (event) => {
      event.preventDefault();
      this.handleSubmit();
    });
  },

  handleSubmit() {
    const selected = this.choices.find((choice) => choice.checked);

    if (!selected) {
      this.showError();
      return;
    }

    if (selected.value !== 'yes') {
      window.location.assign(this.denyRedirect);
      return;
    }

    setConfirmedCookie();
    window.location.assign(this.redirect);
  },

  showError() {
    if (this.error) this.error.hidden = false;
  },

  clearError() {
    if (this.error) this.error.hidden = true;
  },
};

export default ageGate;

ageGate.init();
